import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import type { WorkGroupSummary } from '@/lib/api';

interface WorkGroupCardProps {
  workGroup: WorkGroupSummary;
}

export function WorkGroupCard({ workGroup }: WorkGroupCardProps) {
  const label = workGroup.name?.trim() || 'Untitled work group';
  const typeLabel =
    workGroup.type === 'private' ? 'Private' : workGroup.type === 'project' ? 'Project' : 'Standalone';

  return (
    <Card className="border-border">
      <CardHeader className="space-y-1">
        <CardTitle className="text-base">{label}</CardTitle>
        <CardDescription>
          {typeLabel}
          {workGroup.isArchived ? ' · Archived' : ''}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button variant="outline" size="sm" asChild>
          <Link to={`/workgroups/${workGroup.id}`}>Open</Link>
        </Button>
      </CardContent>
    </Card>
  );
}
